$(() => {
const figures = document.querySelectorAll('.wp-block-video');

figures.forEach((figure) => {
  const video = figure.querySelector('video'),
        caption = figure.querySelector('.wp-element-caption');

  const playButton = document.createElement('button');
  playButton.classList.add('play-button');
  figure.appendChild(playButton);

  function playVideo() {
    const videoSrc = video.getAttribute('src');
    const tracks = Array.from(video.querySelectorAll('track'));

    const popupVideo = document.createElement('video');
    popupVideo.setAttribute('controls', '');
    popupVideo.setAttribute('autoplay', '');
    popupVideo.setAttribute('src', videoSrc);

    tracks.forEach((track) => {
      const popupTrack = document.createElement('track');
      popupTrack.setAttribute('src', track.getAttribute('src'));
      popupTrack.setAttribute('label', track.getAttribute('label'));
      popupTrack.setAttribute('srclang', track.getAttribute('srclang'));
      popupTrack.setAttribute('kind', track.getAttribute('kind'));

      if (track.default) {
        popupTrack.default = true;
      }

      popupVideo.appendChild(popupTrack);
    });

    const videoPopup = document.createElement('div');
    videoPopup.classList.add('video-popup');

    const videoPopupContent = document.createElement('div');
    videoPopupContent.classList.add('video-popup-content');

    const closePopup = document.createElement('span');
    closePopup.classList.add('close-popup');
    closePopup.innerHTML = '&times;';

    videoPopupContent.appendChild(closePopup);
    videoPopupContent.appendChild(popupVideo);
    videoPopup.appendChild(videoPopupContent);
    document.body.appendChild(videoPopup);

    videoPopup.style.display = 'block';

    closePopup.addEventListener('click', () => {
      popupVideo.pause();
      popupVideo.currentTime = 0;
      videoPopup.remove();
    });

    window.addEventListener('click', (event) => {
      if (event.target === videoPopup) {
        popupVideo.pause();
        popupVideo.currentTime = 0;
        videoPopup.remove();
      }
    });
  }

    playButton.addEventListener('click', () => {
      playVideo();
    });

    caption.addEventListener('click', () => {
      playVideo();
    });
  });
});


// WEBPACK FOOTER //
// ./scripts/modules/_popup-video.js